module.exports = FormData;


//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-form-data/lib/browser.js
// module id = 397
// module chunks = 0